import { ReplicaType } from "types";
import Version1 from "./version-1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp6-bridge-collapse-death-toll-rises",
  name: `The Daily Prophet\n'Bridge Collapse: Death Toll Rises'`,
  origin: "Harry Potter and the Half-Blood Prince",

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
